import React, { useEffect, useRef, useState } from "react";
import * as d3 from "d3";

const HeizkurveChart = ({
  data,
  xMin,
  xMax,
  yMin,
  yMax,
  xText,
  yText,
  lineColor = "steelblue",
  axisColor = "black",
  textColor = "black",
  tickColor = "black",
}) => {
  const svgRef = useRef();
  const [dimensions, setDimensions] = useState({ width: 600, height: 400 });

  useEffect(() => {
    const svg = d3.select(svgRef.current);

    // Dynamische Größe aus SVG-Container
    const { width, height } = svgRef.current.getBoundingClientRect();
    setDimensions({ width, height });

    const margin = { top: 20, right: 30, bottom: 50, left: 60 };

    // vorherige Inhalte löschen
    svg.selectAll("*").remove();

    // Scales
    const xScale = d3
      .scaleLinear()
      .domain([xMin, xMax])
      .range([margin.left, width - margin.right]);

    const yScale = d3
      .scaleLinear()
      .domain([yMin, yMax])
      .range([height - margin.bottom, margin.top]);

    // Vertikale Gridlines
    svg
      .append("g")
      .attr("class", "grid-x")
      .attr("transform", `translate(0, ${height - margin.bottom})`)
      .call(
        d3
          .axisBottom(xScale)
          .ticks(18)
          .tickSize(-(height - margin.top - margin.bottom))
          .tickFormat(""),
      )
      .selectAll("line")
      .attr("stroke", "#ccc")
      .attr("stroke-opacity", 0.2);

    // Horizontale Gridlines
    svg
      .append("g")
      .attr("class", "grid-y")
      .attr("transform", `translate(${margin.left},0)`)
      .call(
        d3
          .axisLeft(yScale)
          .ticks(10)
          .tickSize(-(width - margin.left - margin.right))
          .tickFormat(""),
      )
      .selectAll("line")
      .attr("stroke", "#ccc")
      .attr("stroke-opacity", 0.2);

    // X-Achse
    const xAxisGroup = svg
      .append("g")
      .attr("transform", `translate(0, ${height - margin.bottom})`)
      .call(d3.axisBottom(xScale).ticks(18));

    // Achsenlinien färben
    xAxisGroup.selectAll("line, path").attr("stroke", axisColor);
    // Tick-Zahlen färben
    xAxisGroup.selectAll("text").attr("fill", tickColor);

    // Achsenbeschriftung
    xAxisGroup
      .append("text")
      .attr("x", (width - margin.left - margin.right) / 2 + margin.left)
      .attr("y", 40)
      .attr("fill", textColor)
      .attr("text-anchor", "middle")
      .style("font-size", "14px")
      .text(xText);

    // Y-Achse
    const yAxis = d3.axisLeft(yScale).ticks(10);
    const yAxisGroup = svg
      .append("g")
      .attr("transform", `translate(${margin.left},0)`)
      .call(d3.axisLeft(yScale).ticks(10));

    // Achsenlinien färben
    yAxisGroup.selectAll("line, path").attr("stroke", axisColor);
    // Tick-Zahlen färben
    yAxisGroup.selectAll("text").attr("fill", tickColor);

    // Achsenbeschriftung
    yAxisGroup
      .append("text")
      .attr("transform", "rotate(-90)")
      .attr("x", -(height - margin.top - margin.bottom) / 2 - margin.top)
      .attr("y", -45)
      .attr("fill", textColor)
      .attr("text-anchor", "middle")
      .style("font-size", "14px")
      .text(yText);

    const line = d3
      .line()
      .x((d, i) => xScale(data.xValues[i]))
      .y((d) => yScale(d))
      .curve(d3.curveMonotoneX);

    svg
      .append("path")
      .datum(data.yValues)
      .attr("fill", "none")
      .attr("stroke", lineColor)
      .attr("stroke-width", 2)
      .attr("d", line);
  }, [
    data,
    xMin,
    xMax,
    yMin,
    yMax,
    xText,
    yText,
    lineColor,
    axisColor,
    textColor,
    tickColor,
    dimensions.width,
    dimensions.height,
  ]);

  return (
    <div
      style={{
        position: "absolute", // oben links
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
      }}
    >
      <svg ref={svgRef} width="100%" height="100%"></svg>
    </div>
  );
};

export default HeizkurveChart;
